import { EnquiryAssigned } from "./enquiry-assigned";
import { EnquiryAttachment } from "./enquiry-attachment";
import { EnquiryConversation } from "./enquiry-conversation";
import { EnquiryState } from "./enquiry-state";

export class CustomerEnquiryForm {
    // Unique identifier from MongoDB
    id!: string;

    // Full name of the Customer
    name!: string;

    //contact person for the enquiry
    contactPerson!: string;

    // Email address of the customer
    email!: string;

    mobileNumber?: string;

    subject!: string;

    enquiryDetails!: string;

    get enquiryStatus(): string {        
        const enqstatus = this.stateHistory?.at(-1)?.status ?? "draft";        
        return enqstatus;
    }

    createdDate?: Date

    // firstAssignedDate?: Date;

    get firstAssignedDate(): Date | undefined {
        return this.assignedHistory?.at(0)?.timeStamp ?? undefined;
    }
    // assignedTo?: string

    get assignedTo(): string {
        return this.assignedHistory?.at(-1)?.assigneeName ?? "";
    }

    // lastAssignedDate?: Date;

    get lastAssignedDate(): Date | undefined {
        return this.assignedHistory?.at(-1)?.timeStamp ?? undefined;
    }
    conversations?: EnquiryConversation[];

    // convStartDate?: Date;

    get convStartDate(): Date | undefined {
        return this.conversations?.at(0)?.timeStamp ?? undefined;
    }

    // convEndDate?: Date;

    get convEndDate(): Date | undefined {
        return this.conversations?.at(-1)?.timeStamp ?? undefined;
    }

    assignedHistory?: EnquiryAssigned[]

    stateHistory?: EnquiryState[];  

}
